if (!customElements.get('libertas-card-gallery')) {
  class LibertasCardGallery extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.track = this.querySelector('[data-card-gallery-track]');
      this.dots = [...this.querySelectorAll('[data-card-gallery-dot]')];
      this.mobileQuery = window.matchMedia('(max-width: 749px)');
      this.frame = 0;
      this.pointerStart = null;
      this.suppressClick = false;

      if (!this.track) return;

      this.track.addEventListener('scroll', () => this.requestUpdate(), {
        passive: true,
        signal: this.controller.signal,
      });
      this.track.addEventListener('pointerdown', (event) => {
        this.pointerStart = { x: event.clientX, y: event.clientY };
        this.suppressClick = false;
      }, { passive: true, signal: this.controller.signal });
      this.track.addEventListener('pointermove', (event) => {
        if (!this.pointerStart) return;
        const horizontalDistance = Math.abs(event.clientX - this.pointerStart.x);
        const verticalDistance = Math.abs(event.clientY - this.pointerStart.y);
        if (horizontalDistance > 8 && horizontalDistance > verticalDistance) this.suppressClick = true;
      }, { passive: true, signal: this.controller.signal });
      this.track.addEventListener('pointerup', () => {
        this.pointerStart = null;
        window.setTimeout(() => { this.suppressClick = false; }, 0);
      }, { passive: true, signal: this.controller.signal });
      this.closest('a')?.addEventListener('click', (event) => {
        if (!this.suppressClick) return;
        event.preventDefault();
      }, { capture: true, signal: this.controller.signal });
      this.mobileQuery.addEventListener('change', () => {
        if (!this.mobileQuery.matches) this.track.scrollLeft = 0;
        this.requestUpdate();
      }, { signal: this.controller.signal });

      this.update();
    }

    disconnectedCallback() {
      this.controller?.abort();
      window.cancelAnimationFrame(this.frame);
    }

    requestUpdate() {
      window.cancelAnimationFrame(this.frame);
      this.frame = window.requestAnimationFrame(() => this.update());
    }

    update() {
      if (!this.track || this.dots.length === 0) return;
      const slideWidth = this.track.clientWidth;
      if (slideWidth === 0) return;
      const activeIndex = Math.max(0, Math.min(this.dots.length - 1, Math.round(this.track.scrollLeft / slideWidth)));
      this.dots.forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    }
  }

  customElements.define('libertas-card-gallery', LibertasCardGallery);
}
